import store from "../controller/baseController";
import Enums from "../enums/enums";
import userInfo from "../function/userInfo";
import {
  DoDeleteNotificationById,
  DoGetAllNotificationList,
  DoGetUnseenNotificationCount,
  DoSetNotificationIsSeenAll,
  SocketDisconnect,
} from "../helper/notificationHelper";
import {
  ClearTabFromSessionStorage,
  GetTabById,
  GetTabIdFromSessionStorage,
  InsertTabIdToTabDB,
  IsMasterTab,
  UpdateTabMerchantId,
} from "../helper/tabHelper";
let userChannel = null;

export const SetUserChannel = (userId) => {
  if (userChannel) {
    userChannel.close();
  }
  userChannel = new BroadcastChannel(userId);

  userChannel.onmessage = async (event) => {
    if (event.data) {
      switch (event.data.broadcastType) {
        case Enums.BroadcastUserChannelType.AuthenticatedNotification:
          AuthenticatedNotificationFromBroadcast(event.data.request.authenticatedNotificationStatus);
          break;
        case Enums.BroadcastUserChannelType.DisconnectNotification:
          DisconnectNotificationFromBroadcast();
          break;
        case Enums.BroadcastUserChannelType.UpdateNotificationCount:
          UpdateNotificationCountFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.UpdateNotificationList:
          UpdateNotificationListFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.MasterDeleteNotificationById:
          MasterDeleteNotificationByIdFromBroadcast(
            event.data.request.merchantId,
            event.data.request.notificationId,
            event.data.request.isSeen
          );
          break;
        case Enums.BroadcastUserChannelType.MasterGetNotificationListByMerchantId:
          MasterGetNotificationListByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.MasterGetNotificationCountByMerchantId:
          MasterGetNotificationCountByMerchantIdFromBroadcast(event.data.request.merchantId);
          break;
        case Enums.BroadcastUserChannelType.DisconnectNotificationAllTab:
          DisconnectNotificationAllTabFromBroadcast();
          break;
        case Enums.BroadcastUserChannelType.ReCreateTab:
          ReCreateTabFromBroadcast();
          break;
        case Enums.BroadcastUserChannelType.MasterSetNotificationIsSeenAll:
          MasterSetNotificationIsSeenAllFromBroadcast(event.data.request.merchantId);
          break;
      }
    }
  };
};

const AuthenticatedNotificationFromBroadcast = (authenticatedNotificationStatus) => {
  if (authenticatedNotificationStatus == Enums.AuthenticatedNotification.Success) {
    store.commit("MutationSetNotificationReadyToUse", true);
  } else {
    store.commit("MutationSetNotificationReadyToUse", false);
  }
};

const DisconnectNotificationFromBroadcast = () => {
  store.commit("MutationSetNotificationReadyToUse", false);
};

const UpdateNotificationCountFromBroadcast = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  let tab = await GetTabById(tabId);

  if (tab && tab.merchantId == merchantId) {
    await store.commit("MutationSetNotificationCountFromIndexedDB");
  }
};

const UpdateNotificationListFromBroadcast = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  let tab = await GetTabById(tabId);
  if (tab && tab.merchantId == merchantId) {
    await store.commit("MutationSetNotificationListFromIndexedDB");
  }
};

const MasterDeleteNotificationByIdFromBroadcast = (merchantId, notificationId, isSeen) => {
  if (IsMasterTab()) {
    DoDeleteNotificationById(merchantId, notificationId, isSeen);
  }
};

const MasterGetNotificationListByMerchantIdFromBroadcast = (merchantId) => {
  if (IsMasterTab()) {
    DoGetAllNotificationList(merchantId);
  }
};

const MasterGetNotificationCountByMerchantIdFromBroadcast = (merchantId) => {
  if (IsMasterTab()) {
    DoGetUnseenNotificationCount(merchantId);
  }
};

const DisconnectNotificationAllTabFromBroadcast = () => {
  ClearTabFromSessionStorage();
  SocketDisconnect();
  store.commit("SOCKET_disconnect");
};

const ReCreateTabFromBroadcast = async () => {
  let merchantId = userInfo.MerchantId();
  await InsertTabIdToTabDB();
  await UpdateTabMerchantId(merchantId);
  BroadcastMasterGetNotificationCountByMerchantId(merchantId);
};

const MasterSetNotificationIsSeenAllFromBroadcast = async (merchantId) => {
  if (IsMasterTab()) {
    DoSetNotificationIsSeenAll(merchantId);
  }
};

export const BroadcastInUserChannel = () => {
  if (userChannel) {
    userChannel.postMessage("Test");
  }
};

export const BroadcastUserMasterChannel = () => {
  if (userChannel) {
    userChannel.postMessage("toUserChannelMaster");
  }
};

export const BroadcastAuthenticatedNotificationStatus = (authenticatedNotificationStatus) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.AuthenticatedNotification,
      request: {
        authenticatedNotificationStatus: authenticatedNotificationStatus,
      },
    });
  }
};

export const BroadcastDisconnectNotification = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.DisconnectNotification,
      request: null,
    });
  }
};

export const BroadcastIsUpdateNotificationCount = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.UpdateNotificationCount,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastIsUpdateNotificationList = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.UpdateNotificationList,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterDeleteNotificationById = (merchantId, notificationId, isSeen) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterDeleteNotificationById,
      request: {
        merchantId: merchantId,
        notificationId: notificationId,
        isSeen: isSeen,
      },
    });
  }
};

export const BroadcastMasterGetNotificationListByMerchantId = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterGetNotificationListByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastMasterGetNotificationCountByMerchantId = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterGetNotificationCountByMerchantId,
      request: {
        merchantId: merchantId,
      },
    });
  }
};

export const BroadcastDisconnectNotificationAllTab = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.DisconnectNotificationAllTab,
      request: null,
    });
  }
};

export const BroadcastReCreateTab = () => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.ReCreateTab,
      request: null,
    });
  }
};

export const BroadcastMasterSetNotificationIsSeenAll = (merchantId) => {
  if (userChannel) {
    userChannel.postMessage({
      broadcastType: Enums.BroadcastUserChannelType.MasterSetNotificationIsSeenAll,
      request: {
        merchantId: merchantId,
      },
    });
  }
};
